//api/lebo-vod/video/getUploadVideo
import request from "@/axios";
// 获取凭证
export const getUploadVideo = title => {
  return request({
    url: "/lebo-vod/video/getUploadVideo",
    method: "get",
    params: {
      title
    }
  });
};
// 提交审核
export const submitAndApplyExamine = data => {
  return request({
    url: "/lebo-vod/video/submit-and-apply-examine",
    method: "post",
    data: data
  });
};

// 查看本地视频列表
export const getVideoLocal = data => {
  return request({
    url: "/lebo-vod/video/page/local",
    method: "get",
    params: data
  });
};
// 查看分组列表
export const findGroups = (data) => {
  return request({
    url: '/lebo-vod/video/find-groups',
    method: 'get',
    params: data
  })
}
// 查询某分组内的视频列表
export const findByGroupAndDept = (data) => {
  return request({
    url: '/lebo-vod/video/find-by-group-and-dept',
    method: 'get',
    params: data
  })
}

/**
 * 分组中的视频操作: 上移 下移 删除
 * @param  urlparms  
 *      {videoId}/up上移
 *      {videoId}/down下移
 *      {videoId}/remove 删除
 */
export const groupSort = urlparms => {
  return request({
    url: `lebo-vod/video/group-sort/${urlparms}`,
    method: "post",
    data: null
  });
};
//删除分组
export const deleteGroup = data => {
  return request({
    url: `lebo-vod/video/delete-group`,
    method: "post",
    data
  });
};



//新增分类
export const submitClassified = (data) => {
  return request({
    url: '/lebo-vod/videoCatalog/submit',
    method: 'post',
    data
  })
}

// 分类列表查询
export const classifiedList = (data) => {
  return request({
    url: '/lebo-vod/videoCatalog/list',
    method: 'get',
    params: data
  })
}

// 删除分类
export const removeClassified = (data) => {
  return request({
    url: '/lebo-vod/videoCatalog/remove',
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}

// 内容管理列表查询
export const contentList = (data, type) => {
  return request({
    url: '/lebo-vod/video/page/' + type + '',
    method: 'GET',
    params: data
  })
}

//内容管理审批中查询视频分类
export const getclassifiedList = (data) => {
  return request({
    url: '/lebo-vod/videoCatalog/list',
    method: 'GET',
    data
  })
}

//审批操作
export const submitExamine = (data) => {
  return request({
    url: '/lebo-vod/video/submit-examine',
    method: 'POST',
    data
  })
}

//内容管理提交审核
export const submitEditData = (data) => {
  return request({
    url: '/lebo-vod/video/submit-and-apply-examine',
    method: 'POST',
    data
  })
}

// 内容管理删除
export const removeVideo = (data) => {
  return request({
    url: '/lebo-vod/video/remove',
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}
export const getAppInfoData = (data) => {
  return request({
    url: '/lebo-vod/videoapp/list',
    method: 'GET',
    params: data
  })
}
/***************入口管理相关开始*************************************************************************** */
/**
 * 入口管理分页查询
 * @param {isUsed	0本地数据1线上数据} data
 */
export const videoalbumPage = (data) => {
  return request({
    url: 'lebo-vod/videoalbum/page',
    method: 'get',
    params: data
  })
}

/**
 * 删除
 * @param
 */
export const videoalbumRemove = data => {
  return request({
    url: `lebo-vod/videoalbum/remove`,
    method: "post",
    headers: {
      'Content-Type': 'application/json'
    },
    data
  });
};
/**
 * 新增or删除
 * @param {
	"albumType": 0,
	"createDept": 0,
	"createTime": "",
	"createUser": 0,
	"deptId": "",
	"id": 0,
	"isDeleted": 0,
	"isUsed": 0,
	"name": "",
	"originalId": 0,
	"remark": "",
	"reviewStatus": 0,
	"sort": 0,
	"status": 0,
	"tenantId": "",
	"updateTime": "",
	"updateUser": 0
    } data
 */
export const videoalbumSubmit = data => {
  return request({
    url: `lebo-vod/videoalbum/submit`,
    method: "post",
    data
  });
};
/**
 * 入口管理 提交审核
 * @param {
 * attachment	待审核附件		  
 * bizRefrenceId	业务关联id	
 * content	审核内容		 
 * data	自定义审核对象		 
 * status	0草稿 1提交审核 2审核通过 3审核拒绝 4撤销审核	
 * } data
 */
export const videoalbumApplyExamine = data => {
  return request({
    url: `lebo-vod/videoalbum/apply-examine`,
    method: "post",
    data
  });
};
/**
 * 
 * @param {
 * attachment	待审核附件,
 * bizRefrenceId	业务关联id,
 * content	审核内容,
 * data	自定义审核对象,
 * status	0草稿 1提交审核 2审核通过 3审核拒绝 4撤销审核
 * } data
 */
export const videoalbumSubmitExamine = data => {
  return request({
    url: `lebo-vod/videoalbum/submit-examine`,
    method: "post",
    data
  });
};
/***************入口管理相关完结*************************************************************************** */



/**************第三方应用配置管理开始******************************************************************************** */
/**
 * 分页查询
 * api/lebo-vod/videoapp/page 
 * current    当前页
 * size       每页的数量
 * appName    视频APP名称
 * status     视频APP状态
 */
export const videoappPage = (data) => {
  return request({
    url: '/lebo-vod/videoapp/page',
    method: 'get',
    params: data
  })
}
/**
 * 列表查询
 * api/lebo-vod/videoapp/list
 * appName    视频APP名称
 * status     视频APP状态
 */

 
 /**
  * 逻辑删除
  * api/lebo-vod/videoapp/remove
  * ids       主键集合,多个用逗号隔开
  */
export const videoappRemove = data => {
  return request({
    url: '/lebo-vod/videoapp/remove',
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
};

  /**
   * 新增或修改
   * /api/lebo-vod/videoapp/submit
   * id	                      主键id
   * androidDownloadUrl       Android下载H5
   * androidPkg               Android包名
   * androidSchema            Android首页schema
   * appLogo                  应用图标
   * appName                  应用名称
   * iosAppId                 ios应用市场id
   * iosSchema                IOS首页schema
   * isDeleted                是否已删除
   * remark                   备注
   * status                   业务状态
   */
export const videoappSubmit = data => {
  return request({
    url: `lebo-vod/videoapp/submit`,
    method: "post",
    data
  });
};
/**************第三方应用配置管理结束******************************************************************************** */



/**************统计数据******************************************************************************** */
/**
 * 分页查询
 * api/lebo-vod/videoapp/page
 * current    当前页
 * size       每页的数量
 */
export const getStatisticsList = (data, type) => {
  let requestUrl  = ''
  if (type === 'total') {
    requestUrl = '/lebo-vod/reportvideosummary/page'
  } else {
    requestUrl = '/lebo-vod/reportvideodaily/page'
  }
  return request({
    url: requestUrl,
    method: 'get',
    params: data
  })
}
/**************统计数据******************************************************************************** */
